import { render, staticRenderFns } from "./ItensTreeEditor.vue?vue&type=template&id=486d705e&scoped=true"
import script from "./ItensTreeEditor.vue?vue&type=script&lang=js"
export * from "./ItensTreeEditor.vue?vue&type=script&lang=js"
import style0 from "./ItensTreeEditor.vue?vue&type=style&index=0&id=486d705e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d705e",
  null
  
)

export default component.exports